export default "__VITE_ASSET__fae0b18d__"